import Identified from '../../type/base/Identified';
import Named from '../../type/base/Named';

const defaultSelectOptionMapper = <V, L>(entity: Identified & Named) => ({label: entity.name, value: entity.id});

export default defaultSelectOptionMapper;
